import React, { useState } from "react";
import CustomFieldModal from "./CustomFieldModal";
import useCustomField from "../../../../../hooks/useCustomField/UseCustomField";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import EditCustomFieldModal from "./EditCustomFieldModal";
import useUpdateCustomField from "../../../../../hooks/useCustomField/useUpdateCustomField";
import useEditCustomField from "../../../../../hooks/useCustomField/useEditCustomField";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { LuEyeClosed } from "react-icons/lu";
import { LuEye } from "react-icons/lu";
import FieldEditModal from "./FieldEditModal/FieldEditModal";

const Security = ({
  dynamicFields = [],
  hidden,
  onFieldChange, // Accept onFieldChange prop from parent
  require,
  data,
  setData,
  Message,
}) => {
  const [showModal, setShowModal] = useState(false); // State for add field modal
  const [showDeleteModal, setShowDeleteModal] = useState(false); // State for delete confirmation modal
  const [fieldToDelete, setFieldToDelete] = useState(null); // State for the field to delete
  const [division, setDivision] = useState(""); // State for division
  const [message, setMessage] = useState({ type: "", text: "" }); // State for success/error messages

  const [passVisible, setPassVisible] = useState(false);
  const [confirmPassVisible, setConfirmPassVisible] = useState(false);
  const { submitCustomField } = useCustomField();
  const { updateCustomField } = useUpdateCustomField();
  const apiUrls = process.env.REACT_APP_API_URLS;

  const {
    showEditModal,
    selectedField,
    handleOpenEditModal,
    handleCloseEditModal,
    handleSubmitUpdateField,
  } = useEditCustomField();

  // Handle form submission for adding a new field
  const handleSubmit = async (data) => {
    const result = await submitCustomField(data);
    if (result.success) {
      toast.success("Field is Added Succefully", {
        position: "top-right",
        autoClose: 600,
      });

      setShowModal(false);
      setTimeout(() => {
        window.location.reload();
      }, 700);
    } else {
      toast.error(result.message, {
        position: "top-right",
        autoClose: 1000,
      });
      setShowModal(false);
    }
  };

  // Open Add Field Modal
  const handleOpenModal = () => {
    setDivision("Security"); // Set division value here
    setShowModal(true);
  };

  // Open Delete Confirmation Modal
  const handleDeleteField = (field) => {
    setFieldToDelete(field);
    setShowDeleteModal(true);
  };

  // Confirm deletion of the field
  const handleConfirmDelete = async () => {
    if (fieldToDelete) {
      try {
        const response = await axios.delete(
          `${apiUrls}/buyer_settings/custom-fields/${fieldToDelete.id}/`
        );

        if (response.status === 204 || response.status === 200) {
          setMessage({ type: "success", text: "Field deleted successfully!" });
          window.location.reload(); // Reload the page on success
        } else {
          setMessage({ type: "error", text: "Failed to delete the field." });
        }
      } catch (error) {
        setMessage({
          type: "error",
          text: "An error occurred while deleting the field.",
        });
      } finally {
        setShowDeleteModal(false);
        setFieldToDelete(null);
      }
    }
  };

  // Close Delete Confirmation Modal
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setFieldToDelete(null);
  };

  // Handle input changes and notify parent
  const handleInputChange = (e, field) => {
    const { value } = e.target;
    // Update the specific field in the data object
    setData((prevData) => ({
      ...prevData,
      [field.column_name]: value,
    }));
    onFieldChange(field.column_name || field.name, value); // Notify parent of the change
  };

  const [isEditModalOpen, setEditModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    label: "",
    placeholder: "",
    type: "required",
  });

  const handleSave = () => {
    console.log("Form Data Saved:", formData);
    setEditModalOpen(false);
  };

  return (
    <>
      <div className="border-2 border-gray-200 shadow-lg rounded-md p-6 mt-8">
        <h2 className="text-lg font-semibold mb-4">
          <span className="underline">Security :</span>
        </h2>

        {/* Display success/error messages */}
        {/* {message.text && (
          <div
            className={`p-2 mb-4 rounded-md ${
              message.field_type === "success"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {message.text}
          </div>
        )} */}

        {/* Static Fields */}
        <form className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <div className="flex items-center justify-between">
              <label htmlFor="password" className="block">
                Password<span className="text-red-500">*</span>
              </label>
              {Message === "dont show icons" ? (
                <></>
              ) :  (<div className="flex items-center gap-5">
                  <span
                    onClick={() => {
                      setFormData({
                        label: "Password",
                        placeholder: "Enter Password",
                      });
                      setEditModalOpen(true);
                    }}
                    className="text-gray-400 cursor-pointer"
                  >
                    ✎
                  </span>
                  <span className="text-gray-400 cursor-pointer scale-150">
                    x
                  </span>
                </div>
              )}
            </div>
            <div className="relative ">
              <input
                type={`${passVisible ? "text" : "password"}`}
                value={data?.password || ""}
                id="password"
                name="password" // Add a name for the field
                placeholder="Enter Password"
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, { column_name: "password" })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              />
              {passVisible === false ? (
                <div
                  className="absolute top-4 right-4"
                  onClick={() => setPassVisible(!passVisible)}
                >
                  <LuEyeClosed className="text-lg text-gray-500 cursor-pointer" />
                </div>
              ) : (
                <div
                  className="absolute top-4 right-4"
                  onClick={() => setPassVisible(!passVisible)}
                >
                  <LuEye className="text-lg text-gray-500 cursor-pointer" />
                </div>
              )}
            </div>
          </div>

          <div>
            <div className="flex items-center justify-between">
              <label htmlFor="confirmPassword" className="block">
                Confirm Password<span className="text-red-500">*</span>
              </label>
              {Message === "dont show icons" ? (
                <></>
              ) : (<div className="flex items-center gap-5">
                <span
                  onClick={() => {
                    setFormData({
                      label: "Confirm Password",
                      placeholder: "Confirm your password",
                    });
                    setEditModalOpen(true);
                  }}
                  className="text-gray-400 cursor-pointer"
                >
                  ✎
                </span>
                <span className="text-gray-400 cursor-pointer scale-150">
                  x
                </span>
              </div>)}
            </div>
            <div className="relative ">
              <input
                type={`${confirmPassVisible ? "text" : "password"}`}
                value={data?.confirmPassword || ""}
                id="confirmPassword"
                name="confirmPassword" // Add a name for the field
                placeholder="Confirm your Password"
                className="mt-1 block w-full p-2 outline-none rounded-md border-2 border-gray-200 shadow-sm focus:border-gray-300"
                onChange={(e) =>
                  handleInputChange(e, { column_name: "confirmPassword" })
                } // Notify parent of changes
                disabled={require}
                readOnly={require}
              />
              {confirmPassVisible === false ? (
                <div
                  className="absolute top-4 right-4"
                  onClick={() => setConfirmPassVisible(!confirmPassVisible)}
                >
                  <LuEyeClosed className="text-lg text-gray-500 cursor-pointer" />
                </div>
              ) : (
                <div
                  className="absolute top-4 right-4"
                  onClick={() => setConfirmPassVisible(!confirmPassVisible)}
                >
                  <LuEye className="text-lg text-gray-500 cursor-pointer" />
                </div>
              )}
            </div>
          </div>

          {/* Dynamic Fields Rendering */}
          {dynamicFields
            .filter((field) => field) // Filter out undefined or null fields
            .map(
              (field) =>
                field.division == "Security" && (
                  <div key={field.column_name}>
                    <div className="flex justify-between">
                      <label className="block">
                        {field.field_label?.replace(/_/g, " ") ||
                          "Unnamed Field"}
                        {field.is_required && (
                          <span className="text-red-500">*</span>
                        )}
                      </label>
                      <div
                        className={`gap-[5px] ${hidden ? "hidden" : "flex"}`}
                      >
                        <button
                          className="color-[#979797]"
                          type="button"
                          onClick={() => handleOpenEditModal(field)}
                        >
                          <MdOutlineEdit className="color-[#979797]" />
                        </button>
                        <button
                          className="color-[#979797]"
                          type="button"
                          onClick={() => handleDeleteField(field)}
                        >
                          <MdDeleteOutline className="color-[#979797]" />
                        </button>
                      </div>
                    </div>

                    {/* Render Inputs Based on Type */}
                    {field.field_type === "text" ||
                    field.field_type === "date" ||
                    field.field_type === "password" ? (
                      <input
                        type={field.field_type}
                        value={data?.[field.column_name] || ""}
                        name={field.column_name} // Use column_name as the field name
                        placeholder={field.placeholder || ""}
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:border-gray-400"
                        onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                        disabled={require}
                        readOnly={require}
                      />
                    ) : field.field_type === "radio" ||
                      field.field_type === "checkbox" ? (
                      (field.options?.split(",") || []).map((option) => (
                        <div
                          key={option}
                          className="flex items-center space-x-2 mt-1"
                        >
                          <input
                            type={field.field_type}
                            id={option}
                            name={field.column_name}
                            value={data?.[field.column_name] || { option }}
                            // value={option}
                            onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                            disabled={require}
                            readOnly={require}
                          />
                          <label htmlFor={option}>{option}</label>
                        </div>
                      ))
                    ) : field.field_type === "dropdown" ? (
                      <select
                        name={field.column_name} // Use column_name as the field name
                        className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none"
                        onChange={(e) => handleInputChange(e, field)} // Notify parent of changes
                        disabled={require}
                        readOnly={require}
                      >
                        <option disabled>
                          Select {field.column_name?.replace(/_/g, " ")}
                        </option>
                        {(field.options?.split(",") || []).map((option) => (
                          <option key={option} value={option}>
                            {option}
                          </option>
                        ))}
                      </select>
                    ) : null}
                  </div>
                )
            )}
        </form>

        {/* Add Fields Button */}
        <div className="grid grid-cols-2 items-center px-10 mt-6">
          <div className="flex items-center justify-end">
            <button
              onClick={handleOpenModal}
              className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
            >
              Add Field
            </button>
          </div>
          <div className="flex items-center justify-end">
            <button
              onClick={handleOpenModal}
              className="px-3 py-1 bg-gray-200 font-medium text-gray-600 rounded-md"
            >
              Add Field
            </button>
          </div>
        </div>
      </div>

      <FieldEditModal
        isOpen={isEditModalOpen}
        onClose={() => setEditModalOpen(false)}
        onSave={handleSave}
        formData={formData}
        setFormData={setFormData}
        content={"Security"}
      />

      {/* Add Custom Field Modal */}
      <CustomFieldModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmit}
        division={division}
      />

      {/* Edit Custom Field Modal */}
      <EditCustomFieldModal
        isOpen={showEditModal}
        onClose={handleCloseEditModal}
        onSubmit={handleSubmitUpdateField}
        fieldData={selectedField}
      />

      {/* Delete Confirmation Modal */}
      <DeleteConfirmationModal
        isOpen={showDeleteModal}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
      />
      <ToastContainer />
    </>
  );
};

export default Security;
